<template>
  <div>
    <!-- style="margin: 0 5px;" -->
    <div>
      <el-button type="primary" @click="dialogFormVisible = true" icon="el-icon-caret-right">预约演示</el-button>
    </div>
    <div v-if="dialogFormVisible">
      <el-dialog title="预约在线演示" append-to-body :visible.sync="dialogFormVisible" @close="dialogFormVisible = false" :width="width">
        <div style>
          <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone" type="Number" placeholder="请输入联系电话"></el-input>
            </el-form-item>
          </el-form>
          <div style="margin: 20px 0; text-align: left;line-height:100%;">
            <p>专属顾问免费为您提供详细的介绍和演示</p>
            <p>帮助您快速了解产品是否合适。</p>
          </div>
          <el-button type="primary" style="width: 100%;" @click="handleBtn">立即预约</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import API from '@/api/_common'
// import { mapGetters } from 'vuex'
export default {
  name: '',
  data() {
    return {
      dialogFormVisible: false,
      form: {
        phone: ''
      },
      rules: {
        phone: [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      }
    }
  },
  watch: {},
  computed: {
    // ...mapGetters(['userInfo'])
    width() {
      if (window.matchMedia('(max-width: 576px)').matches) {
        return '300px'
      } else {
        return '350px'
      }
    }
  },
  created() {
    // this.form.phone = this.userInfo.account != 'demo' ? this.userInfo.account : ''
  },
  methods: {
    handleBtn() {
      console.log()
      this.$refs.form.validate(valid => {
        if (valid) {
          API.appointmentCreate({ soft: this.utils.getProductCode(), phone: this.form.phone, from: 'web_home' }).then(res => {
            console.log(res)
            this.$Message({
              message: res.message,
              type: 'success',
              duration: '2000'
            })
            this.dialogFormVisible = false
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>